import { useQuery } from '@apollo/client';
import DEFAULT_OPERATIONS from './CmsBlock.gql';

export const useCmsblock = props => {
    const { getCmsBlockQuery } = DEFAULT_OPERATIONS;
    const { data, loading } = useQuery(getCmsBlockQuery, {
        variables: { identifiers: props.identifier }
    });

    const CmsBlockData =
        data &&
        data.cmsBlocks &&
        data.cmsBlocks.items &&
        data.cmsBlocks.items[0]
            ? data.cmsBlocks.items[0]
            : '';
    return {
        CmsBlockData,
        loading
    };
};
